
const m = window.require("discourse/lib/array-tools");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
